import administration from "../assets/svg/administration.svg"
import RoiEstimate from "../assets/svg/RoiEstimate.svg"
import logout from "../assets/svg/logout.svg"
import logo from "../assets/svg/logo.svg"
import Landing from "../assets/png/Landing.png"
import search from "../assets/svg/search.svg"
import logo2 from "../assets/svg/ROI-o-matic.svg"
import loginlogo from "../assets/svg/loginlogo.svg"
import Arow from "../assets/png/Arow.png"
import ActiveEstimate from "../assets/svg/ActiveEstimate.svg"
import ActiveAdmin from "../assets/svg/ActiveAdmin.svg"
import Group from "../assets/png/Group.png"
import riverbedLogo from "../assets/png/riverbed-logo.png"
import LinkExpired from "../assets/png/LinkExpired.png";
import Edit from "../assets/png/edit.png"
import clone from "../assets/png/clone.png"
import Assumption from "../assets/svg/Assumptions.svg"
import activeDownload from "../assets/svg/activeDownload.svg"
import ManageUser from "../assets/svg/ManageUser.svg"
import activeManageUser from "../assets/svg/activeManageUser.svg"
import view from "../assets/png/View.png"
import download from "../assets/png/download.png"
import riverbedcard from "../assets/svg/riverbedcard.svg"
import arowdown from "../assets/png/arowdown.png"
import npm from "../assets/svg/npm.svg"
import aternity from "../assets/svg/aternity.svg"
import iq from "../assets/svg/iq.svg"
import aternityactive from "../assets/svg/aternityactive.svg"
import npmactive from "../assets/svg/npmactive.svg"
import iqactive from "../assets/svg/iqactive.svg"
import actionicon from "../assets/svg/action-icon.svg"
import partneractive from "../assets/svg/partneractive.svg"
import ManageRoles from "../assets/svg/ManageRoles.svg"
import viewodficon from "../assets/svg/viewodficon.svg"
import ManageRolesactive from "../assets/svg/ManageRolesactive.svg"
import PdfBranding from "../assets/svg/PdfBranding.svg"
import activepdfbranding from "../assets/svg/activepdfbranding.svg"
import deactiveicon from "../assets/svg/deactive-icon.svg"
import partner from "../assets/svg/partner.svg"
import modelimgicon from "../assets/svg/model-img-icon.svg"
import circleinfo from "../assets/svg/circle-info.svg"
import pdfediticon from "../assets/svg/pdf-edit-icon.svg"
import haderAssumption from "../assets/svg/haderAssumption.svg"
import Userguide from "../assets/svg/Userguide.svg"
import Delete from "../assets/svg/Delete.svg"
import riverbedlogos from "../assets/png/riverbed-logos.png"
import Rectangle102 from "../assets/png/Rectangle102.png"
import Subtract from "../assets/svg/Subtract.svg"
import Resendinvit from "../assets/svg/Resendinvit.svg"
import Accelerationactive from "../assets/svg/Accelerationactive.svg"
import Acceleration from "../assets/svg/Acceleration.svg"
import NewBusinessicon from "../assets/svg/NewBusinessicon.svg"
import ConsolidationBusiness from "../assets/svg/ConsolidationProposal.svg"
import ExistingCustomeractive from "../assets/svg/ExistingCustomeractive.svg"
import ExistingCustomer from "../assets/svg/ExistingCustomer.svg"
import ExpansionExistingCustomeractive from "../assets/svg/ExpansionExistingCustomeractive.svg"
import ExpansionExistingCustomer from "../assets/svg/ExpansionExistingCustomer.svg"
import RenewalExistingCustomer from "../assets/svg/RenewalExistingCustomer.svg"
import RenewalExistingCustomeractive from "../assets/svg/RenewalExistingCustomeractive.svg"
import NewBusinessactiveicon from "../assets/svg/NewBusinessactiveicon.svg"
import editpdficon from "../assets/svg/Edit-pdf-icon.svg"
import nexticon from "../assets/svg/nexticon.svg"
import Back from "../assets/svg/Back.svg"
import editblue from "../assets/svg/editblue-icon.svg"
import comingSoon from "../assets/svg/comingSoon.svg"
import comingSoon2 from "../assets/svg/comingSoon2.svg"
import  card1  from "../assets/png/card1.png"
import  card2  from "../assets/png/card2.png"
import  card3  from "../assets/png/card3.png"
import  card4  from "../assets/png/card4.png"
import  card5  from "../assets/png/card5.png"
import Pencil from "../assets/png/Pencil.png"
import pdfFooter from "../assets/svg/pdfFooter.svg"
import Atternity_mobile from "../assets/svg/Atternity_mobile.svg"
import Atternity_mobile_Active from "../assets/svg/Atternity_mobile_white.png"
import NpmConsolidate from "../assets/svg/NPM6.svg"
import AtternityConsolidate from "../assets/svg/Aternity6.svg"
import IqConsolidate from "../assets/svg/IQ6.svg"
import AccelerationConsolidate from "../assets/svg/Accelerator6.svg"
import Atternity_mobileConsolidate from "../assets/svg/Atternity_mobile6.svg"
import EmptyFileCalc from "../assets/svg/EmptyFileCalc.svg"
import NewNoExistingtools from "../assets/svg/NewNoExistingtools.svg"
import NewCustomertoolshalf from "../assets/svg/NewCustomertoolshalf.svg"
import FederalConfiguration from "../assets/svg/Federal_Configuration.svg"
import InternalBusiness from "../assets/svg/Federal_Business.svg"
import FederalBusiness from "../assets/svg/Internal_Business.svg"



const Images = {
   pdfFooter,
   Pencil,
   card1,
   card2,
   card3,
   card4,
   card5,
   comingSoon2,
   comingSoon,
   editblue,
   Back,
   nexticon,
   ExpansionExistingCustomeractive,
   ExpansionExistingCustomer,
   RenewalExistingCustomeractive,
   RenewalExistingCustomer,
   ExistingCustomeractive,
   ExistingCustomer,
   NewBusinessactiveicon,
   NewBusinessicon,
   Acceleration,
   Accelerationactive,
   Resendinvit,
   editpdficon,
   Delete,
   deactiveicon,
   PdfBranding,
   activepdfbranding,
   Userguide,
   Subtract,
   Rectangle102,
   riverbedlogos,
   haderAssumption,
   viewodficon,
   pdfediticon,
   modelimgicon,
   circleinfo,
   partner,
   ManageRolesactive,
   ManageRoles,
   partneractive,
   actionicon,
   view,
   iqactive,
   download,
   LinkExpired,
   npm,
   aternity,
   iq,
   npmactive,
   aternityactive,
   RoiEstimate,
   administration,
   logout,
   logo,
   Landing,
   search,
   logo2,
   loginlogo,
   Arow,
   ActiveEstimate,
   ActiveAdmin,
   Group,
   arowdown,
   riverbedLogo,

   riverbedcard,
   Edit,
   clone,
   Assumption,
   activeDownload,

   ManageUser,
   activeManageUser,
   Atternity_mobile,
   Atternity_mobile_Active,
   NpmConsolidate,
   AtternityConsolidate,
   IqConsolidate,
   AccelerationConsolidate,
   Atternity_mobileConsolidate,
   ConsolidationBusiness,
   EmptyFileCalc,
   NewNoExistingtools,
   NewCustomertoolshalf,
   FederalConfiguration,
   InternalBusiness,
   FederalBusiness
}

export default Images;
// riverbedpdflogo